module.exports = __webpack_public_path__ + "img/profile-v2.d23dff36.svg";